import { webRequestClient } from '@/services'

const actions = {
    createItem({ commit, state }, params) {
        return webRequestClient
            .post('data/' + state.type + '/create-item', params.item)
            .then(response => {
                if (response.status === 'OK') {
                    commit(
                        'data/' + state.type + '/setCreatedItem',
                        {
                            item: response.data
                        },
                        { root: true }
                    )
                } else {
                    const errorMessage = 'Error during ' + state.type.replace(/s$/, '') + ' creation'
                    throw Error(errorMessage)
                }
            })
            .catch(error => {
                commit(
                    'notifications/setAddedNotification',
                    {
                        type: 'error',
                        message: error.message
                    },
                    { root: true }
                )
                throw error
            })
    },

    updateItem({ commit, state }, params) {
        return webRequestClient
            .post('data/' + state.type + '/update-item', params.item)
            .then(response => {
                if (response.status === 'OK') {
                    commit(
                        'data/' + state.type + '/setUpdatedItem',
                        {
                            item: response.data
                        },
                        { root: true }
                    )
                } else {
                    const errorMessage = 'Error during ' + state.type.replace(/s$/, '') + ' update'
                    throw Error(errorMessage)
                }
            })
            .catch(error => {
                commit(
                    'notifications/setAddedNotification',
                    {
                        type: 'error',
                        message: error.message
                    },
                    { root: true }
                )
                throw error
            })
    }
}

export default actions
